export const BrandLockup = ({ testIdPrefix = "brand" }) => (
  <span className="trinity-lockup" data-testid={`${testIdPrefix}-lockup`}>
    <img className="trinity-symbol-image" src="/assets/trinity-symbol-transparent.png" alt="" aria-hidden="true" data-testid={`${testIdPrefix}-symbol-image`} />
    <span className="trinity-wordmark" data-testid={`${testIdPrefix}-wordmark`}>
      <span className="trinity-wordmark-name">
        <strong>TRINITY</strong>
        <span>ELECTRONIC</span>
      </span>
      <span className="trinity-wordmark-divider" aria-hidden="true" />
      <small>Clear Vision<br />Every Journey<br />Every Space</small>
    </span>
  </span>
);